import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=9be94bb0"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"
import style0 from "./Batches.vue?vue&type=style&index=0&id=9be94bb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports